const toUnit = v => (typeof v === 'number' ? `${v}px` : v)
const positionMixin = ({ position }) => [
  'position: absolute;',
  ...Object.entries(position).map(([attr, value]) => `${attr}: ${toUnit(value)};`)
]

export default positionMixin
